<template>
    <div class="mb-3">
        <div class="input-group">
            <a class="btn btn-outline-secondary" @click="clear">
                <span class="fa-solid fa-rotate-right"></span>
                クリア...
            </a>
            <input type="text" class="form-control input-long" id="simpleSearchInput" ref="input" autocomplete="off" autofocus
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                :placeholder="placeholder"
                @keyup.enter="find($event)">
            <button type="button" class="btn btn-primary" @click="$emit('find')">
                <span class="fa-solid fa-magnifying-glass"></span>
                検索
            </button>
        </div>
    </div>
</template>

<script>
import { find } from 'lodash';

    export default {
        emits: ["clear", "input", "find", "update:modelValue"],
        props: ["modelValue", "placeholder", "autofocus"],
        methods: {
            clear() {
                this.$emit('clear');
                setTimeout(() => {
                    document.getElementById("simpleSearchInput").focus();
                }, 200);
            },
            find(ev) {
                if (ev && ev.isComposing) return;
                this.$emit('find');
            }
        }
    }
</script>